"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _icons = require("../../../assets/icons");

var _Product = require("./Product.styles");

var ProductImage = function ProductImage(_ref) {
  var image = _ref.image,
      alt = _ref.alt,
      className = _ref.className;
  return (0, _jsxRuntime.jsx)("div", {
    css: _Product.styles.imgBox,
    className: className,
    children: image ? (0, _jsxRuntime.jsx)("img", {
      src: image,
      alt: alt
    }) : (0, _jsxRuntime.jsx)(_icons.Scenery, {})
  });
};

ProductImage.propTypes = {
  image: _propTypes.string,
  alt: _propTypes.string,
  className: _propTypes.string
};
ProductImage.defaultProps = {
  image: undefined,
  alt: 'Product image',
  className: undefined
};
var _default = ProductImage;
exports["default"] = _default;
//# sourceMappingURL=ProductImage.js.map